import React from 'react';
import { createRoot } from 'react-dom/client';

export function PrintBarcodeComponent(barcodeData, userName) {
  const width = '90mm';
  const height = '60mm';

  // Create the iframe
  const iframe = document.createElement('iframe');
  document.body.appendChild(iframe);
  iframe.style.position = 'absolute';
  iframe.style.width = '0px';
  iframe.style.height = '0px';
  iframe.style.border = 'none';

  // Get the document object
  const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

  // Create HTML elements instead of using document.write
  const html = iframeDoc.createElement('html');
  const head = iframeDoc.createElement('head');
  const style = iframeDoc.createElement('style');
  const body = iframeDoc.createElement('body');
  const printContent = iframeDoc.createElement('div');

  // Set attributes
  printContent.id = 'print-content';

  // Add CSS
  style.textContent = `
    @page {
      size: ${width} ${height};
      margin: 0;
    }
    #print-content {
      width: ${width};
      height: ${height};
      margin: 0;
      padding: 0;
    }
    html, body {
      margin: 0;
      padding: 0;
    }
    .div-space-between {
      justify-content: space-between;
    }
    .barcode-sticker {
      height: calc(${height} - 6mm);
      width: calc(${width} - 6mm);
      border: 1px dotted #9e9e9e;
      border-radius: 4px;
      padding: 10px;
    }
    .div-flex-column {
      flex-direction: column;
    }
    .div-align-center {
      align-items: center;
    }
    .div-flex-row,
    .div-flex-column,
    .div-align-center,
    .div-space-between,
    .div-flex-row-column {
      display: flex;
    }
    .div-justify-center {
      display: flex;
      justify-content: center;
    }
    .div-flex-row {
      flex-direction: row;
    }
    .cg-10 {
      column-gap: 10px;
    }
    .cg-20 {
      column-gap: 20px;
    }
    .rg-10 {
      row-gap: 10px;
    }
    .text-xxl {
      font-size: 20px;
      font-family: 'Outfit', sans-serif;
    }
    .text-xl {
      font-size: 18px;
      font-family: 'Outfit', sans-serif;
    }
    .text-md {
      font-size: 14px;
      font-family: 'Outfit', sans-serif;
    }
    .text-sm {
      font-size: 12px;
      font-family: 'Outfit', sans-serif;
    }
    .rg-5 {
      row-gap: 5px;
    }
    .cg-5 {
      column-gap: 5px;
    }
    .text-bold {
      font-weight: 600;
    }
  `;

  // Build the DOM structure
  head.appendChild(style);
  body.appendChild(printContent);
  html.appendChild(head);
  html.appendChild(body);

  // Clear any existing content
  iframeDoc.open();
  iframeDoc.appendChild(html);
  iframeDoc.close();

  // Render React content into the iframe
  const root = createRoot(printContent);
  root.render(
    <div style={{ width, height, boxSizing: 'border-box' }}>
      <div className="barcode-sticker div-flex-column div-space-between">
        {/* Rest of your React component remains unchanged */}
        <div className="div-flex-column rg-5">
          <div>
            <div className="div-flex-row cg-5 div-align-center">
              <img
                src={barcodeData.logoImageUrl}
                alt=""
                height="35px"
                width="35px"
              />
              <span className="text-xl text-bold">
                {barcodeData.organisationName}
              </span>
            </div>
          </div>
          <div className="div-flex-row div-space-between div-align-start">
            <div className="div-flex-column rg-5">
              <div className="div-flex-row cg-5">
                <span className="text-md text-bold">Party:</span>
                <span className="text-md">
                  {barcodeData.businessPartnerName}
                </span>
              </div>
              <div className="div-flex-row cg-5">
                <span className="text-xl text-bold">Number:</span>
                <span className="text-xl">
                  {barcodeData.vehicleTrackingCode}
                </span>
              </div>
              <div className="div-flex-row cg-5">
                <span className="text-xl text-bold">Truck No: </span>
                <span className="text-xl text-bold">
                  {barcodeData.vehicleNumber}
                </span>
              </div>
            </div>
            <div className="div-flex-row cg-5 rg-5">
              <span className="text-md text-bold">Plant:</span>
              <div className="div-flex-column rg-5">
                {barcodeData?.plantList?.slice(0, 3).map((plant) => (
                  <div key={plant} className="text-md">
                    {plant}
                  </div>
                ))}
              </div>
            </div>
          </div>

          <img
            src={`data:image/svg+xml;utf8,${encodeURIComponent(
              barcodeData.barcodeSvg,
            )}`}
            alt=""
            width="315px"
            height="50px"
          />
        </div>
        <div className="div-flex-column rg-5">
          <div className="div-flex-row cg-5">
            <span className="text-md text-bold">Logistic Officer :</span>
            <span className="text-md">{userName}</span>
          </div>
          <div className="div-flex-row cg-5">
            <span className="text-sm text-bold">Time :</span>
            <span className="text-sm">{barcodeData.created}</span>
          </div>
        </div>
      </div>
    </div>,
  );

  setTimeout(() => {
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
    document.body.removeChild(iframe);
  }, 500);
}
